import React from 'react';
import leftPad from 'left-pad';
import downloadjs from 'downloadjs';

import {
    logout,
} from './services/usuario-service';
import {
    urlResumoInscricao,
    urlPDFAvaliacao,
    urlArquivoInscricao,
    urlTextoTrabalhoInscricao,
    urlZipInscricoes,
    urlCSVInscricoes,
} from './services/inscricao-service';
import {
    getAdminForm,
    getInscritosEvento,
    aprovarInscricao,
} from './services/admin-service';
import notification from './Notification';
import Loading from './Loading';
import Footer from './Footer';
import './styles/consultar-inscricoes.css';

class ConsultarInscricoes extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            loadingPage: true,
            loadingDados: true,
            form: {
                inscritos: [],
            },
            searchText: '',
            checkboxTable: {},
            evento_id: '',
        };
    }

    async componentWillMount() {
        try {
            const response = await getAdminForm();
            this.setState({ form: response, loadingPage: false, loadingDados: false, evento_id: response.evento_id });
        } catch (error) {
            this.props.history.replace('/login');
        }
    }

    async onClickSair() {
        await logout();
        this.props.history.replace('/login');
    }

    async atualizarInscritos() {
        this.setState({ loadingPage: true });
        try {
            const response = await getInscritosEvento(this.state.evento_id);
            this.setState({
                form: {
                    ...this.state.form,
                    ...response,
                },
                loadingPage: false,
            });
        } catch (error) {
            notification.show(error.message, true);
        }
    }

    async onClickDownloadSelecionados() {
        const { checkboxTable } = this.state;
        const inscricoesSelecionadas = Object.keys(checkboxTable).filter(x => !!checkboxTable[x]);
        if (inscricoesSelecionadas.length <= 0) {
            alert('Nenhuma inscrição selecionada.');
            return;
        }
        const { e, request } = await urlZipInscricoes(inscricoesSelecionadas);
        if (request.status === 200) {
            downloadjs(e.target.response, 'inscritos-zip.zip', 'application/zip');
        } else {
            alert('Selecione no máximo 10 inscrições.');
        }
    }

    async onAprovarInscricao(index, aprovado) {
        this.setState({ loadingPage: true });
        let form = this.state.form;

        try {
            await aprovarInscricao(form.inscritos[index].token_inscricao, {
                _csrf: form._csrf_token,
                aprovado,
            });

            form.inscritos[index].aprovado = aprovado;
            this.setState({ form, loadingPage: false });
        } catch (error) {
            notification.show(error.message, true);
        }
    }

    onSelectAll(e, inscritosFiltrados) {
        const checkboxTable = {};
        if (e.target.checked) {
            inscritosFiltrados.forEach(x => checkboxTable[x.token_inscricao] = !checkboxTable[x.token_inscricao]);
        }
        this.setState({ checkboxTable });
    }

    render() {
        const {
            loadingPage,
            loadingDados,
            form,
            searchText,
            evento_id,
        } = this.state;
        let { checkboxTable } = this.state;

        const inscritosFiltrados = form.inscritos.filter(x => {
            const numero_inscricao = leftPad(x.numero_inscricao, 4, 0);
            return (
                numero_inscricao.indexOf(searchText.toLowerCase()) > -1 ||
                x.nome_entidade.toLowerCase().indexOf(searchText.toLowerCase()) > -1 ||
                x.nome_autor.toLowerCase().indexOf(searchText.toLowerCase()) > -1 ||
                x.token_inscricao.toLowerCase().indexOf(searchText.toLowerCase()) > -1 ||
                x.nome_categoria.toLowerCase().indexOf(searchText.toLowerCase()) > -1
            );
        });

        return (
            <div className="wrapper">
                {loadingPage && <Loading />}

                <nav className="app-navigation">
                    <section className="container-custom">
                        <a className="app-navigation-title" href="/">
                            <h1 className="app-title">Fórum Gaúcho de Aprendizagem Profissional - FOGAP</h1>
                        </a>
                        <ul className="app-navigation-list float-right">
                            <li className="app-navigation-item">
                                <a className="app-navigation-link" onClick={() => this.onClickSair()}>Sair</a>
                            </li>
                        </ul>
                    </section>
                </nav>
                <div className="container-custom app-body">
                    {
                        loadingDados ?
                            <div>Carregando...</div> :
                            <div>
                                <div className="row">
                                    <div className="column column-50">
                                        <select id="evento" name="evento" value={evento_id} onChange={e => this.setState({ evento_id: e.target.value })}>
                                            {
                                                form.eventos.map((x, index) => <option key={index} value={x.evento_id}>{x.nome}</option>)
                                            }
                                        </select>
                                    </div>
                                    <div className="column column-10">
                                        <input className="button button-primary" type="button" value="Atualizar" onClick={() => this.atualizarInscritos()} />
                                    </div>
                                    <div className="column column-offset-20 column-20">
                                        <input type="text" placeholder="Buscar" autoComplete="off" value={searchText} onChange={e => this.setState({ searchText: e.target.value })} />
                                    </div>
                                </div>
                                <hr />
                                <div className="float-right">
                                    <a className="button button-outline button-baixar-inscricoes" href={urlCSVInscricoes(evento_id)} target="_blank">Baixar CSV inscrições</a>
                                    <button className="button button-outline button-baixar-inscricoes" onClick={() => this.onClickDownloadSelecionados()}>Baixar inscrições selecionadas</button>
                                </div>
                                <table>
                                    <thead>
                                        <tr>
                                            <th><input type="checkbox" onChange={e => this.onSelectAll(e, inscritosFiltrados)} /></th>
                                            <th>N.º Inscrição</th>
                                            <th>Entidade</th>
                                            <th>Autor</th>
                                            <th>Categoria</th>
                                            <th>Opções</th>
                                            <th>Aprovado?</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            inscritosFiltrados.map((x, index) => {
                                                const numero_inscricao = leftPad(x.numero_inscricao, 4, 0);
                                                const onChangeCheckbox = (e) => {
                                                    checkboxTable[x.token_inscricao] = !checkboxTable[x.token_inscricao];
                                                    this.setState({ checkboxTable });
                                                };
                                                return (
                                                    <tr key={index}>
                                                        <td><input checked={!!checkboxTable[x.token_inscricao]} type="checkbox" onChange={onChangeCheckbox} /></td>
                                                        <td className="app-cursor-pointer" onClick={onChangeCheckbox}>{numero_inscricao}</td>
                                                        <td className="app-cursor-pointer" onClick={onChangeCheckbox}>{x.nome_entidade}</td>
                                                        <td className="app-cursor-pointer" onClick={onChangeCheckbox}>{x.nome_autor}</td>
                                                        <td className="app-cursor-pointer" onClick={onChangeCheckbox}>{x.nome_categoria}</td>
                                                        <td>
                                                            <a className="link-baixar" href={urlResumoInscricao(x.token_inscricao, true)} target="_blank">PDF inscrição</a>
                                                            <a className="link-baixar" href={urlPDFAvaliacao(x.token_inscricao, true)} target="_blank">PDF avaliação</a>
                                                            <a className="link-baixar" href={urlTextoTrabalhoInscricao(x.token_inscricao)} target="_blank">Arquivo texto</a>
                                                            {
                                                                !!x.upload ?
                                                                    <a className="link-baixar" href={urlArquivoInscricao(x.token_inscricao, true)} target="_blank">Arquivo anexado</a> :
                                                                    null
                                                            }
                                                        </td>
                                                        <td>
                                                            <div className="center">
                                                                <input type="checkbox" id={`aprovarInscricao-${x.token_inscricao}`} checked={!!x.aprovado} onChange={e => this.onAprovarInscricao(index, e.target.checked)} />
                                                            </div>
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>
                    }
                </div>
                <footer className="footer">
                    <section className="container-custom">
                        <Footer />
                    </section>
                </footer>
            </div>
        );
    }
}

export default ConsultarInscricoes;
